import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http'
import { Constant } from './constants';
import * as fromModels from './models'; // Adjust the path './models' to the correct location of the fromModels namespace
import { Observable, of } from 'rxjs';
import { Utils } from './utils';


@Injectable({
  providedIn: 'root'
})
export class InitService {

  private httpClient: HttpClient
  constructor(private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
   }

   getConfigLocal() {
    return new Promise<any>((resolve, reject) => {
      Constant.updateConfig({   
        "env": "DEV",
        "apibaseurl": "https://localhost:44378/api/",    
        "clientid": "337d2d8e-e1bc-490d-9290-1f7e3450c057",
        "instance": "https://login.microsoftonline.com/",
        "tenant": "rockco.onmicrosoft.com",
        "appinsightkey": "b1286596-73cc-479c-8cd6-8790974ced0f",
        "scope": "https://aml.dev.rockco.com/default",
        "apienvurl":"https://api.dev.rockco.com/",
        "superusers":"ckumar@rocko.com,MMThomas@rockco.com",
        "compusers":"111NGhiwala@rockco.com",
        "latestmonth":"1",
        "latestyr":"2022",
        "nfsreportenable":"Y",
        "basePdfUrl":"http://localhost:3000/",
        "enablecrminteraction":"Y",
        "dynamiccrmbaseurl":"https://rcmceuat2.api.crm.dynamics.com/"
      });
      resolve(Constant.config);
    }).catch(err => {
      console.log("Error occured while initializing service. Detail: " + JSON.stringify(err));
    });
  }

  getConfig() {
    return new Promise<any>((resolve, reject) => {
      let _url = '/api/config';
      //let _url = "http://localhost:63894/api/config";
      this.httpClient.get(_url).toPromise().then(res => {
        Constant.updateConfig(res as any);
        resolve(res);
      })
    }).catch(err => {
      console.log("Error occured while initializing service. Detail: " + JSON.stringify(err));
    });
  }

 


  
}
